import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { preloadOptions } from '../Options/preloadOptions';

import { getRecentQueryOptions } from './recentQueryHelpers';
import { HomeRecentUserPreferencesQuery } from './HomeRecentQueries.graphql';

export const preloadRecent = ({
	cloudId,
	isLoggedIn,
	isWhiteboardViewedEnabled,
	isWhiteboardUpdatedEnabled,
}: {
	cloudId: string;
	isLoggedIn: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isWhiteboardUpdatedEnabled?: boolean;
}) => {
	return waitForAllReturnWhenError([
		query<unknown, {}>(
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			getRecentQueryOptions({
				pill: 'all',
				cloudId,
				endCursor: '',
				isWhiteboardViewedEnabled,
				isWhiteboardUpdatedEnabled,
			}),
		),
		preloadOptions({ isLoggedIn }),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		...(isLoggedIn ? [query({ query: HomeRecentUserPreferencesQuery })] : []),
	]);
};
